import { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { useTranslations } from 'next-intl';

export default function QuestTimer({ timezone = 'Europe/Paris', variant }) {
    const t = useTranslations();
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const updateTimer = () => {
            const now = moment().tz(timezone);
            const endOfDay = moment().tz(timezone).endOf('day');
            const duration = moment.duration(endOfDay.diff(now));
            
            const hours = Math.floor(duration.asHours());
            const minutes = Math.floor(duration.minutes());
            
            if (hours === 0) {
                setTimeLeft(`${minutes} ${minutes > 1 ? t('minutes') : t('minute')}`);
            } else {
                setTimeLeft(`${hours} ${hours > 1 ? t('hours') : t('hour')}`);
            }
        };

        updateTimer();
        const interval = setInterval(updateTimer, 60000); // Update every minute
        
        return () => clearInterval(interval);
    }, [timezone, t]);

    if (variant === "pastel") {
        return (
            <div className="flex items-center gap-1.5 text-sm text-slate-500 dark:text-grayDark-400">
                <svg className="w-4 h-4 text-slate-400 dark:text-grayDark-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <span>{timeLeft}</span>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-1 text-orange-500">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
            </svg>
            <span className="text-xs font-semibold">{timeLeft}</span>
        </div>
    );
}